import { render, staticRenderFns } from "./group-br-report.vue?vue&type=template&id=909e8ca0&scoped=true"
import script from "./group-br-report.vue?vue&type=script&lang=js"
export * from "./group-br-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909e8ca0",
  null
  
)

export default component.exports